{
    "Accessibility menu": "접근성 메뉴",
    "Close": "닫기",
    "Content adjustments": "콘텐츠 조정",
    "Navigation adjustments": "탐색 조정",
    "Text Align": "Text Align",
    "Align Left": "왼쪽 정렬",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "글꼴 크기 조정",
    "Highlight Title": "제목 강조",
    "Highlight Links": "링크 강조",
    "Readable Font": "가독성 좋은 글꼴",
    "Colour adjustments": "색상 조정",
    "Dark Contrast": "어두운 대비",
    "Light Contrast": "밝은 대비",
    "High Contrast": "높은 대비",
    "High Saturation": "높은 채도",
    "Low Saturation": "낮은 채도",
    "Monochrome": "단색",
    "Tools": "도구",
    "Reading Guide": "읽기 가이드",
    "Big Cursor": "큰 커서",
    "Increase Font Size": "글꼴 크기 증가",
    "Decrease Font Size": "글꼴 크기 감소",
    "Letter Spacing": "자간",
    "Line Height": "줄 간격",
    "Font Weight": "글꼴 두께",
    "Dyslexia Font": "난독증용 글꼴",
    "Language": "언어",
    "Accessibility widget": "접근성 메뉴 열기",
    "Accessibility Profiles": "접근성 프로필",
    "Cognitive Disability": "인지 장애",
    "Seizure Safe": "발작 안전",
    "Accessibility statement": "접근성 성명",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "애니메이션 중지",
    "Animation paused": "애니메이션 일시정지됨",
    "Reset all settings": "설정 초기화",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
